import axios from 'axios'
import store from '../../store'
// Define base url
const BASE_URL = '/api/v1/suppliers'

// Define suppliers module
const suppliers = {
  state: {
    data: {},
    errors: {},
    isLoading: false
  },
  getters: {
    suppliersCollection: state => {
      return state.data
    },
    supplierIsFetching: state => {
      return state.isLoading
    }
  },
  mutations: {
    getSuppliersData (state, payload) {
      state.data = payload
    },
    setSuppliersErrors (state, payload) {
      state.errors = payload
    },
    deleteSupplierData (state, payload) {
      const index = state.data.findIndex(i => i.id === payload)
      state.data.splice(index, 1)
    },
    suppliersPaginate (state, payload) {
      state.page = payload
    },
    supplierIsFetching (state, payload) {
      state.isLoading = payload
    }
  },
  actions: {
    async suppliersGetData ({ commit }) {
      try {
        const response = await axios.get(BASE_URL)
        if (response.status === 200) {
          commit('getSuppliersData', response.data)
          return response.status
        }
      } catch (error) {
        commit('setSuppliersErrors', error)
      }
    },
    async suppliersStore ({ commit }, payload) {
      try {
        const response = await axios.post(BASE_URL, payload)
        if (response.status === 201) {
          return response.data.data
        }
      } catch (error) {
        commit('setSuppliersErrors', error.response.data)
      }
    },
    async suppliersUpdate ({ commit }, payload) {
      try {
        const response = await axios.put(`${BASE_URL}/${payload.id}`, payload)
        if (response.status === 202) {
          return response.data.data
        }
      } catch (error) {
        commit('setSuppliersErrors', error.response.data)
      }
    },
    async suppliersDestroy ({ commit }, payload) {
      try {
        const response = await axios.delete(`${BASE_URL}/${payload}`, payload)
        if (response.status === 204) {
          commit('deleteSupplierData', payload)
        }
      } catch (error) {
        commit('setSuppliersErrors', error.response.data)
      }
    },
    async supplierFind ({ commit }, payload) {
      commit('supplierIsFetching', true)
      const response = await axios.post(`${BASE_URL}/search`, payload)
      if (await response.status === 200) {
        await commit('getSuppliersData', await response.data)
        await commit('supplierIsFetching', false)
      }
    }
  }
}

// Export the suppliers module
export default suppliers
